import { Upload5 } from 'blaze-ui/icons'
import { FileTrigger } from 'components/FileTrigger/FileTrigger'
import { useImportMediaFiles } from 'hooks/useImportMediaFiles'
import { useCurrentImageLibrary } from 'hooks/useCurrentImageLibrary'
import { ACCEPTED_AUDIO_MIME_TYPES } from 'screens/Finder/components/views/GalleryView/constants'
import { Button } from 'blaze-ui/Button'
import Styles from './AudioEditorModal.module.scss'
import { AlmanacFile } from 'types'

interface AudioUploadTileProps {
  brandKitId: number
  onSuccess: (newAudio: AlmanacFile) => void
}

export const AudioUploadTile = ({ brandKitId, onSuccess }: AudioUploadTileProps) => {
  const imageLibrary = useCurrentImageLibrary()

  const { uploadImageFiles, isUploading } = useImportMediaFiles(false, (uploadedFiles) => {
    onSuccess(uploadedFiles[0])
  })

  return (
    <FileTrigger
      onSelect={(fileList) => {
        if (!fileList || !imageLibrary?.key) return

        return uploadImageFiles(Array.from(fileList), imageLibrary.key, { brand_kit_id: brandKitId })
      }}
      accept={ACCEPTED_AUDIO_MIME_TYPES}
      allowsMultiple={false}
      aria-label="Upload Audio"
    >
      <Button
        className={Styles.uploadTile}
        variant="ghost"
        size="lg"
        useChildClass
        color="var(--selected-fill)"
        isDisabled={isUploading}
      >
        <div className={Styles.uploadTileContainer}>
          <Upload5 size={24} />
          Upload Audio
        </div>
      </Button>
    </FileTrigger>
  )
}
